import { render } from "./SelectFeeType.vue?vue&type=template&id=70b1a7a5"
import script from "./SelectFeeType.vue?vue&type=script&lang=js"
export * from "./SelectFeeType.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__